import React, { useState } from "react";
import { Button, Typography, Form, Input, Row, Col, message } from "antd-new";
import errors from "./errors";

const API_URL = "https://api.epaypolicy.com/api/v1";

const PaymentMethod = ({ state = {}, props, epayEnabled = false, onTransactionSuccess = () => {} }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	/* ── Credenciales (solo para pruebas) ─────────────────────────────── */
	const PUBLIC_KEY = "6933d515b9fd4f9ca47cbef48a798e10";
	const API_KEY = "7804c42f6d2243d";
	const API_SECRET = "78b9ba33c482457";

	const basicAuth = () => "Basic " + btoa(`${API_KEY}:${API_SECRET}`);

	/* ── Determina el monto neto usando el primer campo definido ─────── */
	  const amountNet = Number(
	    state.total ??
	    state.coveragePrice ??
	    (state.partial_payment_sw ? state.coverageProfit : undefined) ??
	    0
	  );


	/* ── Paso 1: crear token ─────────────────────────────────────────── */
	const createToken = async vals => {
		const res = await fetch(`${API_URL}/tokens`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: basicAuth(), // se convertirá en 'Basic <base64(publicKey:)>'
			},
			body: JSON.stringify({
				payer: state.clientName || "Unknown Payer",
				emailAddress: vals.emailAddress,
				creditCardInformation: {
					accountHolder: state.clientName || "Unknown Payer",
					cardNumber: vals.cardNumber.replace(/\s+/g, ""),
					cvc: vals.cvc,
					month: vals.month,
					year: parseInt(vals.year, 10),
					postalCode: vals.postalCode,
				},
				attributeValues: { invoiceNumber: state.invoiceNumber || 0 },
			}),
		});
		if (res.status !== 201) {
			throw new Error((await res.json()).message || "Token creation failed");
		}
		return res.headers.get("location").split("/").pop();
	};

	/* ── Paso 3: ejecutar transacción ────────────────────────────────── */
	const postTransaction = async (tokenId, vals) => {
		const gross = amountNet;
		const res = await fetch("https://us-central1-fast-in-transit.cloudfunctions.net/createEpayTransaction", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				payer: state.clientName || "Unknown Payer",
				amount: gross,
				comments: state.coverageName || "",
				emailAddress: vals.emailAddress,
				tokenId,
				sendReceipt: true,
				ipAddress: "",
			}),
		});

		if (!res.ok) {
			throw new Error((await res.text()) || "Transaction failed");
		}
		return res.headers.get("location")?.split("/").pop() || "epay‑txn";
	};

	/* ── Submit handler ──────────────────────────────────────────────── */
	const handleSubmit = async () => {
		try {
			const vals = await form.validateFields();
			await errors(state, props);
			if (!amountNet) {
				message.error("Monto a pagar inválido");
				return;
			}
			setLoading(true);
			const tokenId = await createToken(vals);
			const txnId = await postTransaction(tokenId, vals);
			message.success("Pago exitoso 🎉");
			onTransactionSuccess(txnId);
		} catch (err) {
			console.error(err);
			message.error(err.content);
		} finally {
			setLoading(false);
		}
	};

	if (!epayEnabled) return null;

	/* ── UI ──────────────────────────────────────────────────────────── */
	return (
		<>
			<Typography.Title level={4}>Payment (ePayPolicy)</Typography.Title>
			<Form form={form} layout="vertical">
				<Form.Item label="Email" name="emailAddress" rules={[{ required: true, type: "email" }]}>
					<Input />
				</Form.Item>
				<Form.Item label="Card Number" name="cardNumber" rules={[{ required: true }]}>
					<Input maxLength={19} />
				</Form.Item>
				<Form.Item label="Exp. Month" name="month" rules={[{ required: true }]}>
					<Input maxLength={2} />
				</Form.Item>
				<Form.Item label="Exp. Year" name="year" rules={[{ required: true }]}>
					<Input maxLength={4} />
				</Form.Item>
				<Form.Item label="CVC" name="cvc" rules={[{ required: true }]}>
					<Input maxLength={4} />
				</Form.Item>
				<Form.Item label="Postal Code" name="postalCode" rules={[{ required: true }]}>
					<Input />
				</Form.Item>

				<Typography.Paragraph strong>Amount to pay: ${amountNet.toFixed(2)}</Typography.Paragraph>

				<Button type="primary" loading={loading} onClick={handleSubmit} disabled={!amountNet}>
					Pay ${amountNet.toFixed(2)}
				</Button>
			</Form>
		</>
	);
};

export default PaymentMethod;
